class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Cache self-reference to avoid querying DOM on each open() call
    this.cart_drawer = this;

    this.onBodyClick = this.handleBodyClick.bind(this);
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll('[data-cart-icon-bubble]');
  
    if (!cartLinks.length) return;
 
    cartLinks.forEach(cartLink => {
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
  
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }
  
  handleBodyClick(evt) {
    const target = evt.target; 
    if (target.closest('cart-drawer')) {
      this.close();
    }
  }

  connectedCallback() {
    this.backdropClose = this.querySelector('[data-backdrop-overlay]');
    this.backdropClose.addEventListener('click', this.onBodyClick);

    this.drawerClose = this.querySelector('[data-drawer-close]');
    this.drawerClose.addEventListener('click', this.onBodyClick);

    // Add cursor-following icon functionality
    this.handleCursorMove();
  }

  handleCursorMove() { 

    const cursorWrapper = this.querySelector('[data-cursor-hover]'); 

    gsap.set(cursorWrapper, { xPercent: 0, yPercent: 0 });                                                           

    const xTo = gsap.quickTo(cursorWrapper, 'x', { duration: 0.1, ease: 'power3' });
    const yTo = gsap.quickTo(cursorWrapper, 'y', { duration: 0.1, ease: 'power3' });

    this.backdropClose.addEventListener('mousemove', (e) => {
      gsap.to(cursorWrapper, { opacity: 1, scale: 1, duration: 0.1 });
      xTo(e.clientX); 
      yTo(e.clientY);
    });
    this.backdropClose.addEventListener('mouseleave', (e) => { 
      gsap.to(cursorWrapper, { scale: 0, duration: 0.1 }); 
    });
    this.backdropClose.addEventListener('mouseenter', (e) => {
      gsap.to(cursorWrapper, { scale: 1, duration: 0.1 });
    });
  }
  addEventListeners() {
      this.addEventListener('mouseenter', (e) => this.handleMouseEnter(e));
      this.addEventListener('mouseleave', (e) => this.handleMouseLeave(e));
  }


  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // Close quick-view drawer if open
    if(document.querySelector('quick-view-drawer')) {
      document.querySelector('quick-view-drawer').classList.remove('open');
      document.body.classList.remove('overflow-hidden');
      document.body.removeAttribute("data-lenis-prevent");
    }

    // No need to query DOM - cart_drawer is cached in constructor as 'this'
    setTimeout(() => {
      this.cart_drawer.classList.add('open');
      document.body.classList.add('overflow-hidden');
    }, 200);
    document.body.setAttribute("data-lenis-prevent", "true");

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.cart_drawer;
        const focusElement = this.cart_drawer.querySelector('[data-drawer-close]');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }

  close() { 
    this.cart_drawer.classList.remove('open');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.removeAttribute("data-lenis-prevent");
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    // Use sections data from add to cart response
    if (parsedState.sections) {
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = document.getElementById(section.id);
        if (sectionElement && parsedState.sections[section.id]) {
          const html = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');
          const sourceElement = html.querySelector(section.selector);
          const targetElement = sectionElement.querySelector(section.selector) || sectionElement;

          if (sourceElement && targetElement) {
            targetElement.innerHTML = sourceElement.innerHTML;
          }
        }
      });
    }

    // Fetch cart data to get item count
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        const itemCount = cart.item_count;

        this.classList.toggle('is-empty', itemCount === 0);

        // Update cart count bubble
        const cartIcons = document.querySelectorAll('[data-cart-icon-bubble]');
        cartIcons.forEach(icon => {
          const countSpan = icon.querySelector('[data-total-cart-item]');
          if (countSpan) {
            countSpan.textContent = itemCount;
          }

          if (itemCount === 0) {
            icon.classList.add('is-empty-cart');
            icon.querySelector('.cart-count-bubble')?.classList.add('hidden');
          } else {
            icon.classList.remove('is-empty-cart');
            icon.querySelector('.cart-count-bubble')?.classList.remove('hidden');
          }
        });

        setTimeout(() => {
          this.open();
        }, 100);
      })
      .catch((e) => {
        console.error('Error fetching cart:', e);
        // Fallback: open drawer anyway
        setTimeout(() => {
          this.open();
        }, 100);
      });
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
      {
        id: 'mobile-cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);


